import React from 'react';
import { 
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, Button, Skeleton
} from '@mui/material';
import { useActiveAnalysis } from '../services/api/KeynomeAPIHooks';

const styles = {
  dialogTitle: {
    backgroundColor: '#eee',
    display: 'flex',
    alignItems: 'center',
  },
  dialogContent: {
    marginTop: '20px',
    padding: '20px 40px',
  },
  dialogActions: {
    backgroundColor: '#eee',
  },
  sectionHeader: {
    fontWeight: 'bold',
    marginTop: '20px',
    marginBottom: '10px',
  }
};

const ResultsSummaryDialog = ({ open, onClose, sampleId }) => {
  const { data: analysis, isLoading: analysisIsLoading } = useActiveAnalysis(sampleId);

  const hasSummary = analysis?.attributes?.organism_id_summary || analysis?.attributes?.amr_prediction_summary;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={styles.dialogTitle}>
        Analysis Results Summary
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        {analysisIsLoading ? (
          <>
            <Typography variant="h6" sx={styles.sectionHeader}>
              Organism Identification Summary
            </Typography>
            <Skeleton variant="rectangular" height={40} sx={{ mb: 2 }} />
            <Typography variant="h6" sx={styles.sectionHeader}>
              Antimicrobial Resistance Summary
            </Typography>
            <Skeleton variant="rectangular" height={40} />
          </>
        ) : hasSummary ? (
          <>
            {analysis.attributes.organism_id_summary && (
              <>
                <Typography variant="h6" sx={styles.sectionHeader}>
                  Organism Identification Summary
                </Typography>
                <Typography>
                  {analysis.attributes.organism_id_summary}
                </Typography>
              </>
            )}
            {analysis.attributes.amr_prediction_summary && (
              <>
                <Typography variant="h6" sx={styles.sectionHeader}>
                  Antimicrobial Resistance Summary
                </Typography>
                <Typography>
                  {analysis.attributes.amr_prediction_summary}
                </Typography>
              </>
            )}
          </>
        ) : (
          <Typography paragraph>
            No summary is available for this analysis yet.
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="contained"
          color="primary"
          sx={{ marginRight: '20px' }}
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResultsSummaryDialog;